import { useCallback, useRef } from 'react';

export const useAiEditorCache = () => {
  const resultsCache = useRef<Map<string, string>>(new Map());

  const getResult = useCallback(
    (key: string) => resultsCache.current.get(key),
    []
  );

  const setResult = useCallback((key: string, result: string) => {
    resultsCache.current.set(key, result);
  }, []);

  const removeResult = useCallback((key: string) => {
    resultsCache.current.delete(key);
  }, []);

  const clearResults = useCallback(() => resultsCache.current.clear(), []);

  return { getResult, setResult, removeResult, clearResults };
};
